
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { UseFormReturn } from 'react-hook-form';

interface SharedFormFieldProps<T> {
  name: string;
  label: string;
  form: UseFormReturn<T>;
  children: (field: any) => React.ReactNode;
  className?: string;
  description?: string;
}

export const SharedFormField = <T extends Record<string, any>>({
  name,
  label,
  form,
  children,
  className,
  description
}: SharedFormFieldProps<T>) => {
  return (
    <FormField
      control={form.control}
      name={name as any}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            {children(field)}
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
